import React from 'react'
import { useTranslation } from 'react-i18next'
import IconifyIcon from '../wrapper/IconifyIcon'
import './AuthPanel.css'

const AuthPanel = ({
  email,
  password,
  error,
  isSignUp,
  loading,
  onEmailChange,
  onGoogleSignIn,
  onPasswordChange,
  onRequestClose,
  onSubmit,
  onToggleMode,
}) => {
  const { t } = useTranslation()
  const tr = (key, defaultValue) => t(`authPanel.${key}`, { defaultValue })
  const title = isSignUp ? tr('createAccount', 'Criar conta') : tr('welcomeBack', 'Bem-vindo de volta')
  const subtitle = isSignUp
    ? tr('signUpSubtitle', 'Cria a tua conta para guardar filtros, ligares o Telegram e desbloqueares as areas protegidas.')
    : tr('signInSubtitle', 'Entra para continuar nas areas protegidas e guardar o teu estado na plataforma.')

  return (
    <section className="filterbet-auth-surface">
      {onRequestClose ? (
        <button type="button" className="filterbet-auth-close" onClick={onRequestClose} aria-label={tr('closeLogin', 'Fechar login')}>
          <span aria-hidden="true">x</span>
        </button>
      ) : null}
      <div className="filterbet-auth-content">
        <div className="filterbet-auth-header">
          <div className="filterbet-auth-kicker">{tr('access', 'FilterMarket Access')}</div>
          <h1 className="filterbet-auth-title">{title}</h1>
          <p className="filterbet-auth-subtitle">{subtitle}</p>
        </div>

        {error ? <div className="filterbet-auth-error">{error}</div> : null}

        <button
          type="button"
          className="filterbet-auth-google"
          onClick={onGoogleSignIn}
          disabled={loading}
        >
          <IconifyIcon icon="mdi:google" />
          <span>{loading ? tr('connecting', 'A ligar...') : `${isSignUp ? tr('createAccount', 'Criar conta') : tr('signIn', 'Entrar')} ${tr('withGoogle', 'com Google')}`}</span>
        </button>

        <div className="filterbet-auth-divider">{tr('or', 'ou')}</div>

        <form className="filterbet-auth-form" onSubmit={onSubmit}>
          <div className="filterbet-auth-field">
            <label htmlFor="filterbet-auth-email">{tr('email', 'Email')}</label>
            <input
              id="filterbet-auth-email"
              type="email"
              value={email}
              onChange={(event) => onEmailChange(event.target.value)}
              required
              disabled={loading}
              autoComplete="email"
              placeholder={tr('emailPlaceholder', 'nome@email.com')}
            />
          </div>

          <div className="filterbet-auth-field">
            <label htmlFor="filterbet-auth-password">{tr('password', 'Password')}</label>
            <input
              id="filterbet-auth-password"
              type="password"
              value={password}
              onChange={(event) => onPasswordChange(event.target.value)}
              required
              disabled={loading}
              minLength={6}
              autoComplete={isSignUp ? 'new-password' : 'current-password'}
              placeholder={tr('passwordPlaceholder', 'Minimo 6 caracteres')}
            />
          </div>

          <button className="filterbet-auth-submit" type="submit" disabled={loading}>
            {loading ? tr('processing', 'A processar...') : isSignUp ? tr('createAccount', 'Criar conta') : tr('signIn', 'Entrar')}
          </button>
        </form>

        <div className="filterbet-auth-footer">
          <button type="button" className="filterbet-auth-toggle" onClick={onToggleMode} disabled={loading}>
            {isSignUp ? tr('hasAccount', 'Ja tens conta? Entrar') : tr('noAccount', 'Ainda nao tens conta? Criar conta')}
          </button>
        </div>
      </div>
    </section>
  )
}

export default AuthPanel
